import { emptyObj } from 'util/objects'
import selectBase from './selectBase'

const selectCurrentUser = state => selectBase(state) || emptyObj

export default selectCurrentUser
